import React, { useEffect } from "react";
import { ReactComponent as CameraSvg } from "../svgs/camera.svg";

import { StepHeader } from "./StepHeader";
import { FullscreenModal } from "./FullscreenModal";
import {
  WarehouseButtonsFooter,
  WarehouseButton,
  WarehouseButtonGroup,
} from "./WarehouseButtonsFooter";

export const PhotoConfirmation = ({
  title,
  photo,
  onCancel,
  onConfirm,
  onBack,
  retakeButtonText = "No, Take Again",
}) => {
  // Handle Enter key to confirm photo and Escape key to retake
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === "Enter") {
        e.preventDefault();
        e.stopPropagation();
        onConfirm();
      } else if (e.key === "Escape") {
        e.preventDefault();
        e.stopPropagation();
        onCancel();
      }
    };

    window.addEventListener("keydown", handleKeyDown, true);
    return () => window.removeEventListener("keydown", handleKeyDown, true);
  }, [onConfirm, onCancel]);
  return (
    <FullscreenModal>
      <div className="flex flex-col h-full">
        <div className="absolute inset-0">
          <img
            className="w-full h-full object-contain"
            src={photo}
            alt={title}
          />
        </div>
        <StepHeader
          opacity="100%"
          onExit={onCancel}
          isCameraActive
          showModal={false}
        />

        <div className="flex-1" />

        <WarehouseButtonsFooter isCameraActive>
          <WarehouseButtonGroup columns={onBack ? 3 : 2}>
            {onBack && (
              <WarehouseButton
                variant="default"
                onClick={onBack}
                className="!bg-white !text-[#060E23] hover:!bg-gray-100 !border-transparent"
              >
                <div className="flex flex-row justify-center items-center gap-2">
                  <span>Back</span>
                </div>
              </WarehouseButton>
            )}
            <WarehouseButton
              variant="default"
              onClick={onCancel}
              className="!bg-white !text-[#060E23] hover:!bg-gray-100 !border-transparent"
            >
              <div className="flex flex-row justify-center items-center gap-2">
                <CameraSvg className="fill-[#060E23] w-5 h-5" />
                <span>{retakeButtonText}</span>
              </div>
            </WarehouseButton>
            <WarehouseButton variant="primary" onClick={onConfirm}>
              <div className="flex flex-row justify-center items-center gap-2">
                <svg
                  width="18"
                  height="18"
                  viewBox="0 0 26 26"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M11.2252 16.1733L7.93816 12.8777C7.77171 12.717 7.56982 12.6345 7.33249 12.6303C7.09516 12.6259 6.88738 12.7129 6.70916 12.8913C6.53982 13.0604 6.45516 13.263 6.45516 13.499C6.45516 13.7348 6.53982 13.9373 6.70916 14.1067L10.4945 17.9057C10.7025 18.1194 10.946 18.2263 11.2252 18.2263C11.5045 18.2263 11.7482 18.1194 11.9562 17.9057L19.5858 10.2843C19.7556 10.1088 19.8427 9.90243 19.8472 9.66532C19.8514 9.42799 19.7643 9.2201 19.5858 9.04165C19.4076 8.87254 19.1983 8.79021 18.9578 8.79465C18.7174 8.79932 18.5125 8.88621 18.3432 9.05532L11.2252 16.1733ZM13.1695 25.6673C11.4266 25.6673 9.78582 25.3349 8.24716 24.67C6.70849 24.0051 5.36527 23.0991 4.21749 21.952C3.06993 20.8047 2.16349 19.462 1.49815 17.924C0.833044 16.386 0.500488 14.7457 0.500488 13.003C0.500488 11.251 0.832933 9.60421 1.49782 8.06265C2.16271 6.5211 3.06871 5.18021 4.21582 4.03998C5.36316 2.89976 6.70582 1.99698 8.24382 1.33165C9.78182 0.66654 11.4222 0.333984 13.1648 0.333984C14.9168 0.333984 16.5636 0.666428 18.1052 1.33132C19.6467 1.99621 20.9876 2.89854 22.1278 4.03832C23.268 5.1781 24.1708 6.51843 24.8362 8.05932C25.5013 9.60021 25.8338 11.2465 25.8338 12.9983C25.8338 14.7412 25.5014 16.382 24.8365 17.9207C24.1716 19.4593 23.2693 20.8025 22.1295 21.9503C20.9897 23.0979 19.6494 24.0043 18.1085 24.6697C16.5676 25.3348 14.9213 25.6673 13.1695 25.6673ZM13.1672 23.992C16.2292 23.992 18.8266 22.9233 20.9595 20.786C23.0922 18.6487 24.1585 16.0535 24.1585 13.0007C24.1585 9.93865 23.0922 7.34121 20.9595 5.20832C18.8266 3.07565 16.2292 2.00932 13.1672 2.00932C10.1143 2.00932 7.51916 3.07565 5.38182 5.20832C3.24449 7.34121 2.17582 9.93865 2.17582 13.0007C2.17582 16.0535 3.24449 18.6487 5.38182 20.786C7.51916 22.9233 10.1143 23.992 13.1672 23.992Z"
                    fill="white"
                  />
                </svg>
                <span>Use Photo</span>
              </div>
            </WarehouseButton>
          </WarehouseButtonGroup>
        </WarehouseButtonsFooter>
      </div>
    </FullscreenModal>
  );
};
